import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {BRANCH_LEVEL, COMPANY_LEVEL}  from "../common/logic/user-level";
import {UserCreatedAdminArchiveRoute} from "./admin/user-created-admin-archive-route";
import {UserCreatedAdminPrivateRoute} from "./admin/user-created-admin-private-route";
import {UserCreatedAdminPublicRoute}  from "./admin/user-created-admin-public-route";
import {ProductCategoryRoute}         from "./admin/product-route/product-category-route";
import {ProductTemplateRoute}         from "./admin/product-route/product-template-route";
import {TemplateCreationRoute}        from "./admin/template-creation-route/template-creation-route";
import {FolderListRoute}              from "./folder-list/folder-list-route";
import {FolderTemplatesRoute}         from "./folder-templates/folder-templates-route";

export const UserCreatedRoutes = ({next}) => cs(
    consumeContext("userLevels"),
    ({userLevels}) => next([
        //all user routes
        {
            component: FolderListRoute,
            path: "/my-templates",
            allowed: true
        },
        {
            component: FolderTemplatesRoute,
            path: "/my-templates/:folder_id",
            allowed: true
        },

        //admin level routes
        {
            path: "/manage-templates/private",
            component: UserCreatedAdminPrivateRoute,
            allowed: [BRANCH_LEVEL, COMPANY_LEVEL].includes(userLevels?.userLevel)
        },
        {
            path: "/manage-templates/public",
            component: UserCreatedAdminPublicRoute,
            allowed: [BRANCH_LEVEL, COMPANY_LEVEL].includes(userLevels?.userLevel)
        },
        {
            path: "/manage-templates/archive",
            component: UserCreatedAdminArchiveRoute,
            allowed: [BRANCH_LEVEL, COMPANY_LEVEL].includes(userLevels?.userLevel)
        },
        {
            path: "/manage-templates/product",
            component: ProductCategoryRoute,
            allowed: [BRANCH_LEVEL, COMPANY_LEVEL].includes(userLevels?.userLevel)
        },
        {
            path:"/manage-templates/product/:cat_id/:sub_id",
            component: ProductTemplateRoute,
            allowed: [BRANCH_LEVEL, COMPANY_LEVEL].includes(userLevels?.userLevel)
        },
        {
            path:"/manage-templates/create-template/:source_id",
            component: TemplateCreationRoute,
            allowed: [BRANCH_LEVEL, COMPANY_LEVEL].includes(userLevels?.userLevel)
        },
        {
            path:"/manage-templates/update-template/:template_id",
            component: TemplateCreationRoute,
            allowed: [BRANCH_LEVEL, COMPANY_LEVEL].includes(userLevels?.userLevel)
        },
    ]),
);